/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.element = (function() {
    var EXHIBITORS = "<span class='fa fa-users'></span>&nbsp; ";
    var FLOORPLAN = "<span class='fa fa-th'></span>&nbsp; ";
    var doc = document;
    var nList = "";
    var nextIndex = 0;
	var treeNodeEven = true;
    
    
    function makeButton( id, label, elemStyle, hdr) {
        var but = document.createElement( "li");
        but.textContent = label;
        
        but.setAttribute( "class", "nav-btn unselectable");
        but.style.backgroundColor = (elemStyle.clrBg !== "") ? elemStyle.clrBg : hdr.clrBg;
        
        if( elemStyle.gradBg !== "") {
            but.style.background = elemStyle.gradBg;
        }
        else if( elemStyle.clrBg === "" && hdr.gradBg !== "") {
            but.style.background = hdr.gradBg;
        }
        
        but.style.color = (elemStyle.clrText !== "") ? elemStyle.clrText : hdr.clrText;
        
        but.setAttribute( "id", id);
        
        return but;
    }
    
    function makeIconButton( id, label, bgColor, txtColor, icon, iconFirst, alpha) {
        var rgbClr = "";
        var but = document.createElement( "button");
//        but.style.opacity = alpha;
        
         if( alpha !== 1) {
        //      convert bgColor to rgba !!
             rgbClr = "rgba( " + parseInt( bgColor.substr( 1, 2), 16);
             rgbClr += ", " + parseInt( bgColor.substr( 3, 2), 16);
             rgbClr += ", " + parseInt( bgColor.substr( 5, 2), 16);
             bgColor = rgbClr + ", " + alpha + ")";
         }
        
        var spanLablel = document.createElement( "span");
        if( id !== "") {
            spanLablel.setAttribute( "id", id + "Label");
//            spanLablel.style.opacity = alpha;
        }
        var spanIcon = document.createElement( "span");
        var cl = "";
        spanLablel.textContent = label;
        if( icon) {
            cl = "icon " + icon;
            spanIcon.className = cl;
//            spanIcon.style.opacity = alpha;

            if (id == "tb5"){
                spanIcon.style.paddingRight = "5px";
            }
        }
        if( iconFirst) {
            but.appendChild( spanIcon);
            but.appendChild( spanLablel);
        }
        else {
            but.appendChild( spanLablel);
            but.appendChild( spanIcon);
        }
        but.setAttribute( "class", "hdr-btn waves-effect waves-light");
        but.style.backgroundColor = bgColor;
        but.style.color = txtColor;

        if( id !== "") {
            but.setAttribute( "id", id);
        }
        return but;
    }
    
    function makeListItem( id, label, tip, cl) {
        var l = doc.createElement( "li");
        l.setAttribute( "id", id);
        l.className = "unselectable";
        l.textContent = label;
        if( cl) {
            l.className = cl;
        }
        if( tip) {
            l.title = tip;
        }
        return l;
    }
    
    function filterItem( name, label, selected) {
        var opt = doc.createElement( "option");
        opt.setAttribute( "value", name);
        if( selected) {
            opt.setAttribute( "selected", true);
        }
        opt.textContent = label;
        return opt;
    }
    
    function makeViewThumb( view, index, clrBg, grad, clrText) {
        var thumb = doc.createElement( "div");
        var img = doc.createElement( "img");
        var par = doc.createElement( "p");
        
        thumb.className = "thumb";
        thumb.setAttribute( "data-index", index);
        
        img.setAttribute( "src", view.source);
        thumb.appendChild( img);
        par.textContent = view.label;
        thumb.appendChild( par);
        
        thumb.style.backgroundColor = clrBg;
        if( grad !== "") {
            thumb.style.background = grad;
        }
        thumb.style.color = clrText;
        
        return thumb;
    }
    
    function elementById( id) {
        if( !elementById.cache) {
            elementById.cache = [];
        }
        return (elementById.cache[id] = elementById.cache[id] || document.getElementById( id));
    }
    
    function newTreePage( pid, tid) {
        var div;
        var page = document.createElement( "div");
        page.setAttribute( "id", pid);
        page.className = "page";
        
        div = document.createElement( "div");
        div.className = "trcnt";
        div.setAttribute( "id", tid);
        
        page.appendChild( div);
        return page;
    }
        //  z === function to 'decrypt names
    function xmlToTree( xml, ulName, arr, z, clr) {
        var i = 0;
        var node = null;
        var c;
        var htmlRoot = null;
        var xmlRoot = xml.getElementsByTagName( "node")[0];
        var ch = getChildren( xmlRoot);
        nList = "";
        
        if( ch.length > 0) {
            htmlRoot = treeRoot( ulName);
            for( i = 0; i < ch.length; i++) {
                
                c = ch[i];
                node = listChildren( c, arr, z, clr);
                if(i == ch.length-1){
                    node.style.borderBottom = "1px solid #e5e5ef";
                }
                htmlRoot.appendChild( node);
            }
        }
        return htmlRoot;
    }

    function jsonToTree(jsonObject, ulName, arr, z, clr){
        var i = 0;
        var node = null;
        var c;
        var htmlRoot = null;
        var ch = jsonObject;
        nList = "";

        if( ch.length > 0) {
            htmlRoot = treeRoot( ulName);
            for( i = 0; i < ch.length; i++) {
                c = ch[i];
                node = listChildrenJSON( c, arr, z, clr);
                htmlRoot.appendChild( node);
            }
        }
        return htmlRoot;
    }
    
    function listChildrenJSON( jsonObject, arr, z, clr) {
        //var ch = getChildren( node);
        var ch = jsonObject.listItems;
        var lbl = "";
        var i;
        var elem = null;
        var list = null;
        var child = null;
        
        // Handles encryption?
        lbl = (z !== null) ? z(jsonObject.name) : jsonObject.name; 
    
        elem = newTreeNode(jsonObject.boothIndices, lbl, clr); // TreeNode = Parent
        nList += lbl + ",";
        arr.push( jsonObject.boothIndices); 
        //node.appendChild( elem);
        list = doc.createElement( "ul");
        list.style.display = "none";
        
        for (i = 0; i < ch.length; i++){ // Loop through list items here
        
            lbl = (z !== null) ? 
                z(ch[i].exhibitorName) : ch[i].exhibitorName;

            child = newTreeLeaf(ch[i].boothIndices, lbl, clr)
            arr.push( ch[i].boothIndices);

            list.appendChild(child);

        }

        elem.appendChild( list);

        return elem;
    }

    function listChildren( node, arr, z, clr) {
        var ch = getChildren( node);
        var lbl = "";
        var i;
        var elem = null;
        var list = null;
        var child = null;
        
        if( ch.length === 0) {      // 'leaf'
            if(node.hasAttribute('label')) {
                lbl = (z !== null) ? 
                    z(node.attributes.label.value) : node.attributes.label.value;
                elem = newTreeLeaf( node.attributes.data.value, lbl);
                arr.push( node.attributes.data.value);
                node.appendChild( elem);
            }
        }
        else {
            if(node.hasAttribute) {
                if( node.hasAttribute('label')) {
                    lbl = (z !== null) ? 
                        z(node.attributes.label.value) : node.attributes.label.value;
                    elem = newTreeNode( node.attributes.data.value, lbl, clr);
                    nList += lbl + ",";
                    //  ??  push obj with data, type=N/L, elemId
                    arr.push( node.attributes.data.value);
                    node.appendChild( elem);
                    list = doc.createElement( "ul");
                    list.style.display = "none";
                }
                
                for( i = 0; i < ch.length; i++) {
                    child = listChildren( ch[i], arr, z);
                    list.appendChild( child);
                }
                elem.appendChild( list);
            }
        }
        
        return elem;
    }
    
    function treeRoot( ulName) {
        var elem = doc.createElement( "ul");
        elem.setAttribute( "id", ulName);     // i.e.  'trCn'
        elem.setAttribute( "class", "tree");
        
        nextIndex = 0;
        treeNodeEven = true;
        return elem;
    }
    
    function newTreeNode( data, label, clr) {
        var node = doc.createElement( "li");
        var link = doc.createElement( "span");
        var span = doc.createElement( "span");
        link.className = "trigger";
        link.style.color = "";

        if(nextIndex == 0){
            node.style.borderTop = "1";
        }
		
		node.className = treeNodeEven ? "even" : "odd";
		treeNodeEven = !treeNodeEven;
		
        span.textContent = label;
		
        node.appendChild( link);
        node.appendChild( span);
        
        node.setAttribute( "data-index", nextIndex);
        
        nextIndex += 1;
        
        return node;
    }
    
    function newTreeLeaf( data, label) {
        var leaf = doc.createElement( "li");
        var span = doc.createElement( "span");
        //span.className = "label ui-booth";
        span.textContent = label;
      
        leaf.setAttribute( "data-index", nextIndex);
        leaf.className = "comp";
        nextIndex += 1;
        leaf.appendChild( span);
        
        return leaf;
    }
    
    function getChildren( node) {
        var cns = node.childNodes;
        var ar = [];
        var numChild = 0;
        var ch = null;
        var i = 0;
        if( cns) {
            numChild = cns.length;
            for( i = 0; i < numChild; i++) {
                ch = cns[i];
                if( ch.nodeType === 1) {      //  find the elements/tags
                    ar.push( ch);
                }
            }
        }
        return ar;
    }
    
    return {
        ICON_EXHIBITORS : EXHIBITORS,
        ICON_FLOORPLAN : FLOORPLAN,
        ICON_LIST : "<span class='fa fa-list'></span>&nbsp; ",
        ICON_HOME : "&#xf015;",
        ICON_FILTER : "icon-filter",
        ICON_MAP_PIN : "&#xf041;",
        ICON_MINUS : "icon-minus",
        ICON_PLUS : "icon-plus",
        ICON_SALES : "icon-sales",
        ICON_LOGOUT : "icon-logout",
        ICON_PIN : "icon-pin",
        ICON_NONE: "flyout-3d",
        ICON_FIT : "icon-fit",
        ICON_LOCATION : "icon-location",
        elementById : elementById,
        filterItem : filterItem,
        getNodeList: function() {
            return nList;
        },
        makeButton: makeButton,
        makeIconButton : makeIconButton,
        makeListItem : makeListItem,
        makeViewThumb : makeViewThumb,
        newTreePage : newTreePage,
        newTreeLeaf: newTreeLeaf,
        newTreeNode: newTreeNode,
        treeRoot: treeRoot,
        xmlToTree: xmlToTree,
        jsonToTree: jsonToTree
    };
}());